import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
// import router from "./router";

//挂载Vuex
Vue.use(Vuex);

//创建VueX对象
const store = new Vuex.Store({
  state: {
    // 判断是否注册了手机号码 ( 1:去注册 2:已经注册 3:有电话号码但是没有学校id 4:新用户)
    RegisterPhone: 4,
    ClickStream: "", //点击那个宣讲报名
    token: '2de4wWwo2pGA', // 开发环境测试号
    ossConfig: {
      // region以杭州为例（oss-cn-hangzhou），其他region按实际情况填写。
      httpType: "http",
      baseUrl: "www.shouboke.tv",
      endpoint: "oss-accelerate.aliyuncs.com",
      region: "oss-cn-hangzhou",
      // 阿里云主账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM账号进行API访问或日常运维，请登录RAM控制台创建RAM账号。
      accessKeyId: "LTAI5t7HiXvSXcrpWtPKxTWr",
      accessKeySecret: "ibVWzl5dr7ZmGMOFk1vYUakagrzmeI",
      bucket: "shouboke-web"
    },
    orgCenter: {
      isBack: false
    },
    showShareTip: false,
    bannernumber: 5,
    bannerInterval: 4000,
    //存放的键值对就是所要管理的状态
    showBind: false,
    showLogin: false,
    showSkeleton: false,
    showSubWx: false,
    showAgreement: false,
    advjson: [],
    adv: {
      show: false,
      picUrl: "https://shouboke-web.oss-cn-hangzhou.aliyuncs.com/gaokaobao/adv/zhangqian.jpg",
      url: "",
      query: {
        id: 59
      }
    },
    httpDelayed: false,
    userInfo: {
      Ext: {}
    },
    myToken: "Sj4wUpRjP4Os",
    isShare: false,
    mainClient: null,
    connectOK: false,
    connectSocketOK: false,
    chatType: 1,
    errorNum: 0, //403错误的次数
  },
  mutations: {
    setErrorNum(state, errorNum) {
      state.errorNum = errorNum;
    },
    changeChatType(state, Type) {
      state.chatType = Type;
    },
    changeConnectOK(state, ste) {
      state.connectOK = ste;
    },
    changeConnectSocketOK(state, ste) {
      state.connectSocketOK = ste;
    },
    changeMainClient(state, ste) {
      state.mainClient = ste;
    },
    // 修改状态
    ChangeRegisterPhone(state, palyload) {
      console.log('改了东西嘛');
      console.log(palyload);
      state.RegisterPhone = palyload || 1
    },
    ClickStream(state, streamId) {
      console.log("streamId", streamId);
      state.ClickStream = streamId || ""
    },
    isBackOrg(state, ste) {
      state.orgCenter.isBack = ste;
      // Vue.set(state, "showShareTip", ste);
    },
    subwxshare(state, ste) {
      state.showShareTip = ste;
      // Vue.set(state, "showShareTip", ste);
    },
    setadvJson(state, jsondata) {
      Vue.set(state, "advjson", jsondata);
      // state.advjson = jsondata;
    },
    //es6语法，等同edit:funcion(){...}
    subwxState(state, ste) {
      state.showSubWx = ste;
    },

    skeState(state, ste) {
      state.showSkeleton = ste;
    },
    // 关闭广告弹窗
    advState(state, ste) {
      state.adv.show = ste;
    },
    advUrl(state, url, query) {
      state.adv.url = url;
      state.adv.query = query;
    },

    loginState(state, ste) {
      state.showLogin = ste;
      // console.log("sdsdsdsdooooo");
    },

    showBindFunc(state) {
      state.showBind = true;
    },
    closeBindFunc(state) {
      state.showBind = false;
      // console.log("ssss");
    },
    bindState(state, ste) {
      state.showBind = ste;
      // console.log(ste);
    },
    SET_httpDelayed(state, bool) {
      state.httpDelayed = bool;
    },
    SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_ISSHARE(state, bool) {
      state.isShare = bool;
    },
  }
});

Vue.prototype.$setErrorNum = function (type) {
  store.commit("setErrorNum", type);
};
Vue.prototype.$setChatType = function (type) {
  store.commit("changeChatType", type);
};
Vue.prototype.$setConnectOK = function (ste) {
  store.commit("changeConnectOK", ste);
};
Vue.prototype.$setConnectSocketOK = function (ste) {
  store.commit("changeConnectSocketOK", ste);
};

Vue.prototype.$setMainClient = function (obj) {
  store.commit("changeMainClient", obj);
};
Vue.prototype.$setSocketConnectOK = function (ste) {
  store.commit("changeSocketConnectOK", ste);
};
// isBackOrg
Vue.prototype.$setOrgBack = function (ste) {
  store.commit("isBackOrg", ste);
};

Vue.prototype.$showBind = function () {
  store.commit("showBindFunc");
};

Vue.prototype.$Register = function (sta, streamId) {
  store.commit("ChangeRegisterPhone", sta);
  if (streamId) {
    store.commit("ClickStream", streamId);
  }
};

Vue.prototype.$closeBind = function () {
  store.commit("closeBindFunc");
};

Vue.prototype.$showLogin = function (ste) {
  store.commit("loginState", ste);
};

Vue.prototype.$showAdv = function (ste) {
  store.commit("advState", ste);
};

Vue.prototype.$setAdv = function (url, query = {}) {
  store.commit("advUrl", url, query);
};

Vue.prototype.$showSke = function (ste) {


  store.commit("skeState", ste);

};

Vue.prototype.$showSubwx = function (ste) {
  let _subwx = lycamWeb.getCookie("_subwx");
  if (_subwx == "true") {
    if (ste) {
      lycamWeb.setCookie("_subwx", false, 1);
    }
    store.commit("subwxState", ste);
  } else {
    store.commit("subwxState", false);
  }
};

Vue.prototype.$showShareLay = function (ste) {
  try {
    wx.miniProgram.getEnv(function (res) {
      if (res.miniprogram) {
        alert("小程序分享正在升级..");
      } else {
        store.commit("subwxshare", ste);
      }
      console.log(res.miniprogram); // true
    });
  } catch (e) {
    store.commit("subwxshare", ste);
  }
};

// Vue.prototype.$getBanner = function (dom) {

//   return new Promise((resolve, reject) => {
//     if (dom && dom.length > 0) {
//       var height = dom[0].$el.clientHeight;
//       if (dom <= 0) {

//       }
//     }
//   });

// }
// 改变httpDelayed
Vue.prototype.$changeHttpDelayed = function (bool) {
  store.commit("SET_httpDelayed", bool);
}

// 改变isShare
Vue.prototype.$changeIsShare = function (bool) {
  store.commit("SET_ISSHARE", bool);
}

Vue.prototype.$setUserInfo = function (userInfo) {
  console.log("userInfo", userInfo);
  store.commit("SET_USERINFO", userInfo)
}

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js